import { useAuthState } from '@auth/hooks';
import { BaseLayout } from '@core/components/BaseLayout';
import { TransparentFooter } from '@core/components/TransparentFooter';
import { routes } from '@core/routes';
import { Outlet, useLocation, Navigate } from 'react-router-dom';

import * as styles from './LoginLayout.css';

export function LoginLayout() {
  const { isAuthenticated } = useAuthState();
  const location = useLocation();

  // If user is already authenticated and on the login page,
  // redirect them to the dashboard or the requested page
  if (isAuthenticated && location.pathname === routes.login) {
    const params = new URLSearchParams(location.search);
    const redirectTo = params.get('redirectTo') || routes.communityGroups.root;

    return <Navigate to={redirectTo} />;
  }

  return (
    <div className={styles.loginLayoutContainer}>
      <BaseLayout
        className={styles.centeredMainContent}
        footer={
          <div className={styles.transparentFooterWrapper}>
            <TransparentFooter />
          </div>
        }
      >
        <Outlet />
      </BaseLayout>
    </div>
  );
}
